import { CtaButton } from "@components/buttons/CtaButton";
import { Box } from "@mui/material";

interface ButtonConfig {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export interface WorkflowActionsStickyFooterProps {
  primaryButtonConfig?: ButtonConfig;
  secondaryButtonConfig?: ButtonConfig;
}

const TWO_BUTTON_WIDTH = "230px";
const SINGLE_BUTTON_WIDTH = "366px";

export const WorkflowActionsStickyFooter = ({
  primaryButtonConfig,
  secondaryButtonConfig,
}: WorkflowActionsStickyFooterProps) => {
  if (!primaryButtonConfig && !secondaryButtonConfig) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        backgroundColor: "white",
        padding: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "24px",
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      {secondaryButtonConfig && primaryButtonConfig ? (
        <>
          <CtaButton
            {...secondaryButtonConfig}
            variant="primary-alt"
            width={TWO_BUTTON_WIDTH}
          />
          <CtaButton
            {...primaryButtonConfig}
            variant="primary"
            width={TWO_BUTTON_WIDTH}
          />
        </>
      ) : primaryButtonConfig ? (
        <CtaButton
          {...primaryButtonConfig}
          variant="primary"
          width={SINGLE_BUTTON_WIDTH}
        />
      ) : null}
    </Box>
  );
};
